/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FolderModel = {
  readonly id?: number;
  name: string;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  system_type?: FolderModel.system_type | null;
  report_date?: string | null;
  md_documents?: number | null;
  parent_folder?: number | null;
  firm?: number | null;
  company?: number | null;
};
export namespace FolderModel {
  export enum system_type {
    DAILY_NAV_ROOT = 'daily_nav_root',
    DAILY_NAV_COMPANY = 'daily_nav_company',
    DAILY_NAV_REPORT_DATE = 'daily_nav_report_date',
  }
}

